export default "__VITE_ASSET__CD4wpffW__"